<div class="modal-header">
    <h6 class="modal-title"><i class="bi bi-shield-check"></i> Mobile & EmailID</h6>
</div>
<div class="modal-body">
    <form class="g-3" name="VerificationForm" (ngSubmit)="Verification(VerificationForm)" #VerificationForm="ngForm"
        novalidate>
        <div class="row">
            <div class="col-md-12">
                <label for="Email" class="text-label-dark">Email <span
                        class="mandatory-field">*</span></label>
                <input type="Email" class="form-control" placeholder="Ex. xyz@domain.com" id="Email"
                    name="Email" [(ngModel)]="PreonboardinSetupDetail.Email" #Email="ngModel"
                    oninput="this.value = this.value.toUpperCase()"
                    pattern="[A-Za-z0-9._+\-']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$" required>
                <div class="invalid-feedback">
                    Please enter a valid personal email id! eg. 'example&#64;abc.com'
                </div>
            </div>
            <div class="col-md-12">
                <label for="MobileNo" class="text-label-dark">Contact No <span class="mandatory-field">*</span></label>
                <input type="text" maxlength="10" pattern="^[0-9]\d*$" class="form-control"
                    placeholder="Ex. 9876543210" (keypress)="common.NumberOnly($event)" id="MobileNo"
                    name="MobileNo" [(ngModel)]="PreonboardinSetupDetail.MobileNo"
                    #MobileNo="ngModel" required>
                <div class="invalid-feedback">
                    Please enter 10 digit contact no!
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-primary btn-sm" [disabled]="isDisabled"><i
        class="bi bi-chevron-right" *ngIf="!isDisabled"></i>
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
    {{!isDisabled?'Update':'Loading...'}}</button>

    <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled" (click)="close()"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Cancel':'Loading...'}}</button>
</div>